<template>
  <div>
    <h5>
      <p class="ml-5 mt-3">Report Performance Pengajuan Pos</p>
    </h5>
    <CRow>
      <CCol col="6">
        <CCard class="ml-5">
          <CCardBody>
            <CInput
              label="Start Date"
              class="mb-0"
              type="date"
              v-model="request.start_date"
              required
              horizontal
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="6">
        <CCard class="mr-5">
          <CCardBody>
            <CInput
              label="End Date"
              class="mb-0"
              type="date"
              v-model="request.end_date"
              horizontal
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="form-group mr-4">
      <CCol col="12 ">
        <CButton color="primary" class="float-right" @click="getDataPerformance"
          >Submit</CButton
        >
      </CCol>
    </CRow>
    <CRow col="12">
      <CCol
        class="ml-4 mr-4 mt-4 shadow-lg p-3 mb-5 bg-body rounded"
        v-if="seriesReject.length !== 0"
      >
        <CCardBody class="text-center">
          <strong><h4>Reason Reject</h4></strong>
          <div id="chart">
            <apexchart
              type="bar"
              :options="chartOptionsReject"
              :series="seriesReject"
            ></apexchart>
          </div>
        </CCardBody>
      </CCol>
    </CRow>
    <CRow col="12">
      <CCol
        class="ml-4 mr-4 mt-4 shadow-lg p-3 mb-5 bg-body rounded"
        v-if="seriesFollowUp.length !== 0"
      >
        <CCardBody class="text-center">
          <strong><h4>Reason Follow Up</h4></strong>
          <div id="chart">
            <apexchart
              type="bar"
              :options="chartOptionsFollowUp"
              :series="seriesFollowUp"
            ></apexchart>
          </div>
        </CCardBody>
      </CCol>
    </CRow>
    <CRow col="12">
      <CCol
        class="ml-4 mr-4 mt-4 shadow-lg p-3 mb-5 bg-body rounded"
        v-if="seriesDistrict.length !== 0"
      >
        <CCardBody class="text-center">
          <strong><h4>Performance</h4></strong>
          <div id="chart">
            <apexchart
              type="bar"
              height="400"
              :options="chartOptionDistrict"
              :series="seriesDistrict"
            ></apexchart>
          </div>
        </CCardBody>
      </CCol>
    </CRow>
  </div>
</template>

<script>
// import usersData from './UsersData'
import Vue from "vue";
import jwt from "jsonwebtoken";
import VueApexCharts from "vue-apexcharts";
import { AGENT_FLAG } from "../../agent_registration/app/enum/index.js";
import ACCOUNT_GROUP from "../../../../../app/enum/groups.js";
import ReportUseCase from "../app/usecase/index.js";

Vue.component("apexchart", VueApexCharts);

export default {
  name: "Performance",
  data() {
    return {
      categoriesTotal: "Total",
      categoriesTotalReject: "Total Reject",
      categoriesTotalFollowUp: "Total Follow Up",
      request: {
        start_date: "",
        end_date: "",
      },
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      seriesFollowUp: [],
      seriesReject: [],
      seriesDistrict: [],
      chartOptionsFollowUp: {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptionsReject: {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
      chartOptionDistrict: {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        colors: ["#bea925", "#2596be", "#00FF00", "#FF0000"],
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  mounted() {
    this.authentication();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === ACCOUNT_GROUP.NPOS ||
        data.account_group === ACCOUNT_GROUP.ADMIN ||
        data.account_group === ACCOUNT_GROUP.ADMINISTRATOR
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleStartDate(event) {
      this.startDate = event;
    },
    handleEndDate(event) {
      this.endDate = event;
    },
    async getDataPerformance() {
      try {
        var queryString = Object.keys(this.request)
          .map((key) => key + "=" + this.request[key])
          .join("&");
        const { data, err } = await ReportUseCase.getPerformance(queryString);
        if (err) {
          await this.$swal.fire({
            icon: "error",
            text: err,
          });
        } else {
          if (data) {
            this.seriesFollowUp = [];
            this.seriesReject = [];
            this.seriesDistrict = [];
            this.chartOptionsReject.xaxis.categories = [];
            this.chartOptionsFollowUp.xaxis.categories = [];
            this.chartOptionDistrict.xaxis.categories = [];
            this.filterPerformanceDistrict(data.district_performance);
            this.filterPerformanceReject(data.reason_reject);
            this.filterPerformanceFollowUp(data.reason_follow_up);
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    filterPerformanceReject(performanceReject) {
      var reject = {
        name: this.categoriesTotalReject,
        data: [],
      };
      performanceReject.forEach((element) => {
        reject.data.push({
          x: element.reason_name,
          y: element.total,
        });
      });
      performanceReject.length > 0 ? this.seriesReject.push(reject) : "";
    },
    filterPerformanceFollowUp(performanceFollowUp) {
      var FollowUp = {
        name: this.categoriesTotalFollowUp,
        data: [],
      };
      performanceFollowUp.forEach((element) => {
        FollowUp.data.push({
          x: element.reason_name,
          y: element.total,
        });
      });
      performanceFollowUp.length > 0 ? this.seriesFollowUp.push(FollowUp) : "";
    },
    filterPerformanceDistrict(performanceDistrict) {
      var followUp = {
        name: AGENT_FLAG.FOLLOW_UP,
        data: [],
      };
      var topUp = {
        name: AGENT_FLAG.TOP_UP,
        data: [],
      };
      var approve = {
        name: AGENT_FLAG.APPROVE,
        data: [],
      };
      var reject = {
        name: AGENT_FLAG.REJECT,
        data: [],
      };
      performanceDistrict.forEach((element) => {
        followUp.data.push(element.follow_up);
        topUp.data.push(element.top_up);
        approve.data.push(element.approve);
        reject.data.push(element.reject);
        this.chartOptionDistrict.xaxis.categories.push(this.categoriesTotal);
      });
      performanceDistrict.length > 0
        ? this.seriesDistrict.push(followUp, topUp, approve, reject)
        : "";
    },
  },
};
</script>

<style scoped>
@import "../Report.css";
</style>
